import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { getCardImagePath } from '../../../utils/credit-cards';
export const DefaultCreditCardModal = ({ card, hideModal, onConfirmDefault, isLoading, }) => {
    const { cardBrand, cardExpiryMonth, cardExpiryYear, cardNumberLast4 } = card;
    const cardExpiryYearLast2 = cardExpiryYear === null || cardExpiryYear === void 0 ? void 0 : cardExpiryYear.slice(-2);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Confirm Your New Default Payment Method"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "New Default Payment Method"),
            React.createElement("div", { className: "sui-flex sui-gap-2 sui-pt-[50px]" },
                React.createElement("div", { className: "sui-flex sui-gap-2" },
                    React.createElement("img", { width: 33, height: "auto", src: getCardImagePath(cardBrand, cardBrand), alt: "Credit card logo" }),
                    React.createElement(Typography, null,
                        " ****",
                        cardNumberLast4)),
                React.createElement(Typography, null, cardExpiryMonth &&
                    cardExpiryYear &&
                    `Exp ${cardExpiryMonth}/${cardExpiryYearLast2}`)),
            React.createElement("br", null)),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "Cancel"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmDefault, "data-testid": "confirm-new-def-payment-btn" }, "Set New Default Payment Method")))));
};
DefaultCreditCardModal.displayName = 'DefaultCreditCardModal';
